import { render, staticRenderFns } from "./table-title.vue?vue&type=template&id=2b8890f3&scoped=true&"
import script from "./table-title.vue?vue&type=script&lang=js&"
export * from "./table-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8890f3",
  null
  
)

export default component.exports